<template>
  <app-window
    :value="dialog"
    actions
  >
    <template v-slot:body>
      <v-form
        ref="form"
        v-model="valid"
      >
        <v-row class="mx-2">
          <h4 class="title secondary--text">
            Histórico de Alterações da Responsabilidade
          </h4>
        </v-row>
        <v-row>
          <v-col cols="12">
            <historico-responsabilidade-list
              :responsabilidade="responsabilidadeHistorico"
              :etapa="etapa"
            />
          </v-col>
        </v-row>
        <v-row class="mx-2">
          <h4 class="title secondary--text mr-4">
            Formulário de Alteração da Responsabilidade
          </h4>
          <v-chip
            v-if="!isEditada"
            class="mr-4"
            color="success"
            outlined
            small
          >
            Nenhuma alteração realizada
          </v-chip>
          <v-chip
            v-else
            class="mr-4"
            color="warning"
            outlined
            small
          >
            Alterações pendentes
          </v-chip>
        </v-row>
        <v-row class="mx-2">
          <v-col cols="12">
            <v-text-field
              id="titulo"
              v-model.trim="responsabilidadeAux.titulo"
              :rules="rules.titulo"
              color="primary"
              label="Responsabilidade"
              prepend-icon="done"
              required
              tabindex="1"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-select
              v-model="responsabilidadeAux.dificuldade"
              :items="dificuldades"
              :rules="rules.dificuldade"
              class="mr-4"
              color="primary"
              item-text="descricao"
              label="Nível de Dificuldade"
              prepend-icon="how_to_reg"
              required
              tabindex="2"
              return-object
            >
              <template v-slot:item="data">
                <v-list-item-content>
                  <v-list-item-title>
                    {{
                      data.item.descricao
                    }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>
            </v-select>
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-select
              v-model="responsabilidadeAux.impacto"
              :items="impactos"
              :rules="rules.impacto"
              color="primary"
              item-text="descricao"
              label="Nível de Impacto"
              prepend-icon="warning"
              required
              tabindex="3"
              return-object
            >
              <template v-slot:item="data">
                <v-list-item-content>
                  <v-list-item-title>
                    {{
                      data.item.descricao
                    }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>
            </v-select>
          </v-col>
          <v-col cols="8">
            <v-autocomplete
              v-model="responsabilidadeAux.competenciasTecnicas"
              :items="competencias"
              :rules="rules.competencias"
              :search-input.sync="search"
              chips
              class="mr-4"
              color="primary"
              deletable-chips
              item-text="nomeAtual"
              label="Competências técnicas"
              placeholder="Digite para pesquisar..."
              multiple
              no-results-text="Nenhum resultado encontrado."
              prepend-icon="build"
              required
              return-object
              tabindex="4"
              @change="search = ''"
            >
              <template v-slot:selection="data">
                <v-chip
                  :color="
                    data.item.unidades.length === 0 ? 'secondary' : 'grey'
                  "
                  :input-value="data.selected"
                  class="chip--select-multi"
                  close
                  text-color="white"
                  @click:close="removeCompetencia(data.item)"
                >
                  {{ data.item.nomeAtual }}
                </v-chip>
              </template>
              <template v-slot:no-data>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      Nenhum resultado encontrado para
                      <strong>{{ search }}</strong>. Para adicionar uma nova competência,
                      <kbd>clique</kbd> no botão ao lado.
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  class="mt-4"
                  color="primary"
                  dark
                  text
                  @click="toogleCadastroCompetencia"
                  v-on="on"
                >
                  Adicionar
                  <v-icon class="ml-2">
                    add_circle
                  </v-icon>
                </v-btn>
              </template>
              <span>Clique para adicionar uma competência</span>
            </v-tooltip>
          </v-col>
          <v-spacer />
        </v-row>
      </v-form>

      <cadastro-edicao-competencia
        :competencia="competencia"
        :etapa="etapa"
        :is-edicao="false"
        :mapeamento="mapeamento"
        :toogle="toogleCadastroCompetencia"
        :unidades-selecionadas="unidadesSelecionadas"
        :visibilidade="dialogCompetencia"
        @hide="toogleCadastroCompetencia"
        @return="(value) => addCompetencia(value)"
      />
    </template>
    <template v-slot:actions>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn
            :disabled="!valid || !isEditada"
            class="mr-2"
            color="primary"
            tabindex="7"
            @click="editar"
            v-on="on"
          >
            Salvar
          </v-btn>
        </template>
        <span>Clique no botão para editar a responsabilidade</span>
      </v-tooltip>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn
            :disabled="!isEditada"
            color="primary"
            outlined
            tabindex="7"
            @click="assignResponsabilidade"
            v-on="on"
          >
            Restaurar
          </v-btn>
        </template>
        <span>Clique no botão para restaurar a responsabilidade</span>
      </v-tooltip>
    </template>
  </app-window>
</template>

<script>
import { mapGetters } from 'vuex';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import CadastroEdicaoCompetencia from '@/components/mapeamento/CadastroEdicaoCompetencia';
import HistoricoResponsabilidadeList from '@/components/mapeamento/HistoricoResponsabilidadeList';
import AppWindow from '@/components/core/AppWindow';

const responsabilidadeRepository = RepositoryFactory.get('responsabilidade');

export default {
  name: 'EdicaoResponsabilidade',

  components: { CadastroEdicaoCompetencia, HistoricoResponsabilidadeList, AppWindow },

  props: {
    dialog: {
      type: Object,
      default: () => ({}),
    },
    responsabilidade: {
      type: Object,
      default() {
        return {
          impacto: null,
          dificuldade: null,
        };
      },
    },
    etapa: {
      type: String,
      default() {
        return {};
      },
    },
    unidadesSelecionadas: {
      type: Array,
      required: false,
      default: () => ([]),
    },
  },

  data() {
    return {
      responsabilidadeHistorico: null,
      responsabilidadeAux: {
        titulo: null,
        dificuldade: null,
        impacto: null,
        competenciasTecnicas: [],
      },
      dificuldades: [
        {
          id: 'UM',
          descricao:
            '1 - Atividade está organizada ou estruturada '
            + '(requer aplicação básica de suas competências para realizar a atividade)',
        },
        {
          id: 'DOIS',
          descricao:
            '2 - Atividade pouco organizada ou estruturada '
            + '(requer aplicação intermediária de suas competências para realizar a atividade)',
        },
        {
          id: 'TRES',
          descricao:
            '3 - Atividade ainda sem organização ou estruturas definidas '
            + '(requer aplicação máxima de suas competências para realizar a atividade)',
        },
      ],
      impactos: [
        { id: 'UM', valor: 1, descricao: '1 - Fica limitado ao setor' },
        { id: 'DOIS', valor: 2, descricao: '2 - Afeta várias áreas, mas é administrável' },
        { id: 'TRES', valor: 3, descricao: '3 - Ultrapassa os portões da instituição' },
      ],
      rules: {
        titulo: [(v) => !!v || 'O título da responsabilidade não pode ficar em branco'],
        impacto: [(v) => !!v || 'Selecione o nível de impacto da responsabilidade'],
        dificuldade: [(v) => !!v || 'Selecione o nível de dificuldade da responsabilidade'],
        competencias: [(v) => (v !== undefined && v.length > 0) || 'Adicione pelo menos uma competência técnica'],
      },
      competencia: { nome: '', unidades: [] },
      dialogCompetencia: false,
      valid: false,
      search: null,
    };
  },

  computed: {
    ...mapGetters({
      getCompetenciasTecnicas: 'competencia/getCompetenciasTecnicas',
    }),
    mapeamento() {
      if (this.etapa === 'validacao') {
        return this.$store.state.mapeamento.mapeamento;
      }
      return this.$store.state.mapeamento.mapeamentoComissao;
    },
    competenciasTecnicas: {
      get() {
        return this.$store.state.competencia.competenciasTecnicas;
      },
      set(value) {
        const payload = { tipo: 'TECNICA', competencias: value.sort((a, b) => a.nome.localeCompare(b.nome)) };
        this.$store.dispatch('competencia/setCompetencias', payload);
      },
    },
    competencias() {
      return this.getCompetenciasTecnicas({
        unidadeId: this.responsabilidade.unidade.id,
        mapeamentoId: this.responsabilidade.mapeamento.id,
      });
    },
    isEditada() {
      let editada = this.responsabilidadeAux.titulo !== this.responsabilidade.tituloAtual
        || this.responsabilidadeAux.impacto.id !== this.responsabilidade.impactoAtual.id
        || this.responsabilidadeAux.dificuldade.id !== this.responsabilidade.dificuldadeAtual.id;

      if (editada) {
        return editada;
      }

      editada = this.responsabilidadeAux.competenciasTecnicas.length
        !== this.responsabilidade.competenciasAtuais.length;

      if (editada) {
        return editada;
      }

      for (const cAux of this.responsabilidadeAux.competenciasTecnicas) {
        if (!this.responsabilidade.competenciasAtuais.some((c) => c.id === cAux.id)) {
          editada = true;
          break;
        }
      }

      return editada;
    },
  },

  created() {
    this.responsabilidadeHistorico = this.responsabilidade;
    this.assignResponsabilidade();
  },

  methods: {
    assignResponsabilidade() {
      if (this.responsabilidade && this.responsabilidade.dificuldade && this.responsabilidade.impacto) {
        this.responsabilidadeAux.titulo = this.responsabilidade.tituloAtual;
        this.responsabilidadeAux.impacto = this.responsabilidade.impactoAtual;
        this.responsabilidadeAux.dificuldade = this.responsabilidade.dificuldadeAtual;
        this.responsabilidadeAux.competenciasTecnicas = [...this.responsabilidade.competenciasAtuais];
      }
    },
    editar() {
      const item = { ...this.responsabilidade };
      item.titulo = this.responsabilidadeAux.titulo;
      item.impacto = this.responsabilidadeAux.impacto;
      item.dificuldade = this.responsabilidadeAux.dificuldade;
      item.competenciasTecnicas = this.responsabilidadeAux.competenciasTecnicas;
      item.competenciasAtuais = null;

      let etapa = '';
      switch (this.etapa) {
        case 'cadastro':
          etapa = 'CADASTRO_RESPONSABILIDADES';
          break;
        case 'normalizacao':
          etapa = 'NORMALIZACAO_RESPONSABILIDADES';
          break;
        case 'validacao':
          etapa = 'VALIDACAO_RESPONSABILIDADES';
          break;
        case 'consolidacao':
          etapa = 'CONSOLIDACAO_RESPONSABILIDADES';
          break;
        default:
          break;
      }

      responsabilidadeRepository.update(etapa, item.id, item).then((res) => {
        this.$emit('updated', res);
        this.responsabilidadeHistorico = res.data;
      });
    },
    addCompetencia(competencia) {
      this.responsabilidadeAux.competenciasTecnicas.push(competencia);
    },
    removeCompetencia(item) {
      const index = this.responsabilidadeAux.competenciasTecnicas.findIndex((c) => c.id === item.id);
      if (index !== -1) {
        this.responsabilidadeAux.competenciasTecnicas.splice(index, 1);
      }
    },
    toogleCadastroCompetencia() {
      this.competencia.unidades = [this.responsabilidade.unidade];
      this.dialogCompetencia = !this.dialogCompetencia;

      if (!this.dialogCompetencia) {
        this.competencia.id = null;
        this.competencia.nome = '';
      }
    },
  },
};
</script>
